// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__n0gOs","menuBody":"Menu_menuBody__LN-Z4","menuBody__item":"Menu_menuBody__item__aTYJE","active":"Menu_active__7Dmbd","menuBody__main":"Menu_menuBody__main__5c-e6"};